module.exports = __webpack_public_path__ + "static/media/marker-store.abba23cf.svg";